<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'table-component',
  extends: TablePage,
  props: {
    treeCode: String,
  },
  data() {
    return {
      params: {
        auditTemplateId: '',
      },
    };
  },
  watch: {
    treeCode(val) {
      this.params.auditTemplateId = val;
      this.getList();
    },
  },
  async created() {
    await this.getConfigList('unmatched_acceptance_list');
  },
  methods: {
    beforeGetList() {
      if (this.params.auditTemplateId) {
        return true;
      }
      return false;
    },
  },
};
</script>
